import { MULTICALL_CONTRACT_ADDRESS } from '../../constants';
import { Decimal } from '../../datastructures';
import { NostraToken, Nullable } from '../../interfaces';
import { MultiCallContract } from '../../services';
import nostraTokenListAtom from './nostraTokenListAtom';
import { createAsyncAtom } from '../../lib/state';
import { RpcProvider } from 'starknet';
import rpcProviderAtom from '../rpcProviderAtom';

export type NostraTokenTotalSupplyMap = { [nostraTokenAddress: string]: Decimal };

const POLLING_INTERVAL_IN_MS = 300000; // 5 minutes
const RESPONSE_CHUNK_SIZE = 3;

const fetchData = async (nostraTokens: NostraToken[], provider: RpcProvider) => {
  try {
    const calldata = nostraTokens.map(nostraToken => {
      return {
        contractAddress: nostraToken.address,
        entrypoint: 'totalSupply',
      };
    });

    const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

    const result = await multiCallContract.aggregate(calldata);

    if (!result) {
      return null;
    }

    const nostraTokenTotalSupplyMap: NostraTokenTotalSupplyMap = {};

    for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
      const nostraToken = nostraTokens[i / RESPONSE_CHUNK_SIZE];

      // Index 1,2 is for totalSupply
      const totalSupply = new Decimal({ low: result[i + 1], high: result[i + 2] }, nostraToken.tokenPrecision);

      nostraTokenTotalSupplyMap[nostraToken.address] = totalSupply;
    }

    return nostraTokenTotalSupplyMap;
  } catch (error) {
    console.error(`useNostraTokenTotalSupply - Failed to load nostra token total supply!`, error);

    return null;
  }
};

const nostraTokenTotalSupplyAtom = createAsyncAtom<Nullable<NostraTokenTotalSupplyMap>>(
  async get => {
    const nostraTokenList = await get(nostraTokenListAtom);
    const provider = await get(rpcProviderAtom);

    const result = await fetchData(nostraTokenList, provider);

    return result;
  },
  POLLING_INTERVAL_IN_MS,
  [
    'lend-and-borrow-deposit',
    'lend-and-borrow-withdraw',
    'lend-and-borrow-borrow',
    'lend-and-borrow-repay',
    'lend-and-borrow-adjust',
    'unstake-and-deposit',
    'user-refresh',
  ],
);

export default nostraTokenTotalSupplyAtom;
